<template>
  <span>
    <div class="flex-itens">
      <div v-if="max === 1000 && canReloadScore" class="pointer"
       @click="reloadAnalisy">
        <div class="content-imgs">

          <b-tooltip target="viewScoreIcon" triggers="hover" title="Visualizar Score"></b-tooltip>
          <b-tooltip target="updateScore" triggers="hover" title="Atualizar Score"></b-tooltip>


          <svg 
          id="viewScoreIcon"
          v-if="redirectScore"
          @click="scoreRedirect()" 
          xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 256 256"><path fill="currentColor" d="M245.48 125.57c-.34-.78-8.66-19.23-27.24-37.81C201 70.54 171.38 50 128 50S55 70.54 37.76 87.76c-18.58 18.58-26.9 37-27.24 37.81a6 6 0 0 0 0 4.88c.34.77 8.66 19.22 27.24 37.8C55 185.47 84.62 206 128 206s73-20.53 90.24-37.75c18.58-18.58 26.9-37 27.24-37.8a6 6 0 0 0 0-4.88M128 194c-31.38 0-58.78-11.42-81.45-33.93A134.8 134.8 0 0 1 22.69 128a134.6 134.6 0 0 1 23.86-32.06C69.22 73.42 96.62 62 128 62s58.78 11.42 81.45 33.94A134.6 134.6 0 0 1 233.31 128C226.94 140.21 195 194 128 194m0-112a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46m0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34"/></svg>
          <div id="updateScore">
            <b-img
              :class="{ loading: loading }"
              :src="require('@assets/images/raio.svg')"
            ></b-img>
          </div>
      </div>
      </div>
    </div>
      <NewProgressBar :type="'SellerScore'" :valor="number"/>
  </span>
</template>

<script>
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'

import AnalysisService from '@services/resources/AnalysisService'
import {AccessLevel} from "@views/configurations/enums/accessLevel";
var service = AnalysisService.build()

export default {
  components:{
    NewProgressBar
  },
  props: {
    value: {
      required: false,
      type: Number,
      default: 0
    },
    max: {
      required: false,
      type: Number,
      default: 0
    },
    link: {
      required: false,
      type: String,
      default: ""
    },
    data: {
      required: false,
      type: Object,
      default: () => ({})
    },
    redirectScore:{
      required: false,
      type: Number,
      default: 0
    }
  },
  computed: {
    canReloadScore() {
      return this.$canAction('risk_analysis_reload_score', AccessLevel.READER)
    },
  },
  data() {
    return {
      allResult: 0,
      loading: false,
      maxResult: 100,
      number: 0,
      result: 0,
    }
  },
  mounted() {
    this.number = this.value
  },
  methods: {
    scoreRedirect(){
      const url = '/analises/participante/' + this.redirectScore;
      this.$router.push(url);
    },
    reloadAnalisy() {
      this.loading = true
      service
        .read('/update-score/' + this.link.split('/')[3])
        .then((resp) => {
          this.number = resp.avg_user_scores;
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style lang="scss" scoped>
.flex-itens {
  height: 20px;
  display: flex;
  justify-content: flex-end;
  p {
    font-weight: 600;
    font-size: 18px;
    letter-spacing: 0.2px;
    color: #000000;
  }
  svg {
    margin-top: 7px;
    cursor: pointer;
    
  }
  display: flex;
  gap: 20px;
}

.pointer {
  cursor: pointer;
}

.link-sem-analise {
  p {
    font-weight: 400;
    font-size: 13px;
    letter-spacing: 0.2px;
    color: #81858e;
    margin-top: 10px;
  }
}

.link {
  cursor: pointer;
  p {
    font-weight: 400;
    font-size: 13px;
    letter-spacing: 0.2px;
    color: #81858e;
    margin-top: 10px;
  }
}

.date {
  p {
    font-weight: 400;
    font-size: 11px;
    letter-spacing: 0.2px;
    color: #81858e;
    margin-top: 10px;
  }
}

p,
span {
  font-family: 'Montserrat';
  font-style: normal;
  margin: 0;
}

.loading {
  -webkit-animation: spin 4s linear infinite;
  -moz-animation: spin 4s linear infinite;
  animation: spin 4s linear infinite;
}
@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.link-hover:hover{
  p {
    color: #00897b;
  }
}

.content-imgs{
  display: flex;
  align-items: center;
  gap: 15px;

  svg{ 
    margin: 0 !important;
  }
}
</style>